import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { store as StoreInformationsApi } from '@teem/constants/api';
import { country as CountryApi } from '@teem/core/constants/api';
import { objectToFormData } from '@teem/helpers/functions';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StoreInformationService {

  constructor(
    private httpClient: HttpClient
  ) { }

  public getMyStore() {
    return this.httpClient.get(`${StoreInformationsApi.getMyStore}`)
  }

  public getProductInfo() {
    return this.httpClient.get(`${StoreInformationsApi.productInformation}`)
  }

  public getServiceInfo() {
    return this.httpClient.get(`${StoreInformationsApi.serviceInformation}`)
  }

  public getKSACities() {
    return this.httpClient.get(`${CountryApi.cities}?limit=100`)
  }

  public getTemplateInfo() {
    return this.httpClient.get(`${StoreInformationsApi.templateInformation}`)
  }

  public getBranchesInfo(){
    return this.httpClient.get(`${StoreInformationsApi.branchesInfo}?limit=100`)
  }

  public editBranchInfo(branchId : any){
    return this.httpClient.get(`${StoreInformationsApi.editBranch}?branch_id=${branchId}`)
  }

  public deleteBranch(branchId : any){
    return this.httpClient.post(`${StoreInformationsApi.deleteBranch(branchId)}`,[])
  }

   public updateBranchStatus(branchId : any,branchStatus: any){
    return this.httpClient.get(`${StoreInformationsApi.updateBranchStatus}?branch_id=${branchId}&branch_status=${branchStatus}`)
  }
  

  public getCities(regionId: string) {
    if (regionId)
      return this.httpClient.get(`${CountryApi.cities}?region_id=${regionId}`)
    else
      return this.httpClient.get(`${CountryApi.cities}?limit=100`)
  }

  public getDistricts(cityId: string) {
    if (cityId)
      return this.httpClient.get(`${CountryApi.districts}?city_id=${cityId}`)
    else
      return this.httpClient.get(`${CountryApi.districts}?limit=100`)
  }

  public getDeliveryCostByDistrict(districtId: string) {
    return this.httpClient.get(`${CountryApi.delivery_cost}?district_id=${districtId}`);
  }

  public updateMyStore(params: any, options?: any) {
    if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
      let fd = objectToFormData(params);
      fd.append('_method', 'put');
      return this.httpClient.post(`${StoreInformationsApi.updateMyStore}`, fd)
    } else {
      return this.httpClient.put(`${StoreInformationsApi.updateMyStore}`, params)
    }
  }

  public uploadFile(formData) {
    // return this.httpClient.post(`${UserApi.uploadLogo}`, formData);
    return this.httpClient.post<any>(`${StoreInformationsApi.uploadLogo}`, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  // public removeFile() {
  //   return this.httpClient.delete(`${StoreInformationsApi.removeLogo}`)
  // }
  public removeFile(type) {
    return this.httpClient.delete(`${StoreInformationsApi.removeLogo(type)}`)
  }

  public updateProductInfo(params: any, options?: any) {
    if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
      let fd = objectToFormData(params);
      fd.append('_method', 'put');
      return this.httpClient.post(`${StoreInformationsApi.productInformation}`, fd)
    } else {
      return this.httpClient.put(`${StoreInformationsApi.productInformation}`, params)
    }
  }

  public updateBranchTemplateInfo(params: any, options?: any) {
    if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
      let fd = objectToFormData(params);
      fd.append('_method', 'put');
      return this.httpClient.post(`${StoreInformationsApi.branchTemplateInformation}`, fd)
    } else {
      return this.httpClient.put(`${StoreInformationsApi.branchTemplateInformation}`, params)
    }
  }
  
  public createStoreBranch(params: any, options?: any) {
    if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
      let fd = objectToFormData(params);
      fd.append('_method', 'put');
      return this.httpClient.post(`${StoreInformationsApi.createBranch}`, fd)
    } else {
      return this.httpClient.put(`${StoreInformationsApi.createBranch}`, params)
    }
  }
  

  public updateServiceInfo(params: any, options?: any) {
    if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
      let fd = objectToFormData(params);
      fd.append('_method', 'put');
      return this.httpClient.post(`${StoreInformationsApi.serviceInformation}`, fd)
    } else {
      return this.httpClient.put(`${StoreInformationsApi.serviceInformation}`, params)
    }
  }

  public getFoodicsInfo() {
    return this.httpClient.get(`${StoreInformationsApi.foodicsInfo}`)
  }

  public updateFoodicsProducts(params: any) {
    return this.httpClient.post(`${StoreInformationsApi.updateFoodicsProducts}`, params)
  }

  public disconnectFoodics() {
    return this.httpClient.get(`${StoreInformationsApi.disconnectFoodics}`)
  }

  checkSlug(params: any): Observable<any> {
    return this.httpClient.post<{ exists: boolean }>(`${StoreInformationsApi.checkSlug}`, params);        
  }

  checkBranchSlug(params: any): Observable<any> {
    return this.httpClient.post<{ exists: boolean }>(`${StoreInformationsApi.checkBranchSlug}`, params);        
  }

  public updateFoodicsBranch() {
    return this.httpClient.get(`${StoreInformationsApi.updateFoodicsBranch}`)
  }

  public setReceivingBranch(params: any) {
    return this.httpClient.post(`${StoreInformationsApi.setReceivingBranch}`, params)
  }

}
